export default [{
  date: '10-01',
  value: 116
}, {
  date: '10-02',
  value: 129
}, {
  date: '10-03',
  value: 135
}, {
  date: '10-04',
  value: 86
}, {
  date: '10-05',
  value: 73
}, {
  date: '10-06',
  value: 85
}, {
  date: '10-07',
  value: 73
}, {
  date: '10-08',
  value: 68
}, {
  date: '10-09',
  value: 92
}, {
  date: '10-10',
  value: 130
}, {
  date: '10-11',
  value: 245
}, {
  date: '10-12',
  value: 139
}, {
  date: '10-13',
  value: 115
}, {
  date: '10-14',
  value: 111
}, {
  date: '10-15',
  value: 309
}, {
  date: '10-16',
  value: 245
}, {
  date: '10-17',
  value: 139
}, {
  date: '10-18',
  value: 115
}, {
  date: '10-19',
  value: 111
}, {
  date: '10-20',
  value: 309
}, {
  date: '10-21',
  value: 245
}, {
  date: '10-22',
  value: 139
}, {
  date: '10-23',
  value: 115
}, {
  date: '10-24',
  value: 111
}, {
  date: '10-25',
  value: 309
}, {
  date: '10-26',
  value: 245
}, {
  date: '10-27',
  value: 139
}, {
  date: '10-28',
  value: 115
}, {
  date: '10-29',
  value: 111
}, {
  date: '10-30',
  value: 309
}]
